export default "__VITE_ASSET__VCN7DDtj__"